<div class="container">
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="form-container">
    <div class="item-container">
      <mat-form-field appearance="outline" class="item">
        <mat-label>E-Mail</mat-label>
        <input matInput formControlName="name" autocomplete="username">
      </mat-form-field>
    </div>
    <div class="item-container">
      <mat-form-field appearance="outline" class="item">
        <mat-label>Password</mat-label>
        <input matInput formControlName="password" type="password" autocomplete="current-password">
      </mat-form-field>
    </div>
    <div class="item-container">
      <button mat-raised-button type="submit" [disabled]="loginForm.invalid" class="item btn-large color">Login</button>
    </div>
  </form>
</div>
<hr class="line">